export default "__VITE_ASSET__cf6148ad__"